import { Box, Typography } from "@mui/material";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Styled from "./Styled";
import CustomIcon from "components/customIcon";
import classNames from "classnames";
import { LanguageContext } from "../../../components/language";
import "moment/locale/ru";
import { upperCase } from "lodash";
import enGb from "date-fns/locale/en-GB";
registerLocale("en-gb", enGb);

export const monthNamesLocal = [
    "JANUARY",
    "FEBRUARY",
    "MARCH",
    "APRIL",
    "MAY",
    "JUNE",
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
];
export const weekDaysMin = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

const RangePicker = ({ defaultDate = {}, onChange, dayAmounts = {}, design, getAmounts }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [monthCount, setMonthCount] = useState(2);
    const { t } = useContext(LanguageContext);

    const handleChange = (dates) => {
        const startDate = dates[0];
        const endDate = dates[1];

        setStartDate(startDate);
        setStartDate(endDate);

        let start = moment(startDate).valueOf();
        let end = moment(endDate).valueOf();

        onChange({
            startDate: isNaN(start) ? null : start,
            endDate: moment(start).isSame(end) || isNaN(end) ? null : end,
        });
    };

    const handleResize = (e) => {
        if (window.innerWidth < 1200 && monthCount === 2) setMonthCount(1);
        else if (window.innerWidth >= 1200) setMonthCount(2);
    };

    useEffect(() => {
        if (!moment(defaultDate.startDate).isSame(startDate, "day"))
            setStartDate(defaultDate.startDate);
        if (!moment(defaultDate.endDate).isSame(endDate, "day")) setEndDate(defaultDate.endDate);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultDate.startDate, defaultDate.endDate]);

    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return handleResize;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Styled design={design}>
            <DatePicker
                selected={startDate}
                startDate={startDate}
                endDate={endDate}
                onChange={handleChange}
                inline
                selectsRange
                minDate={new Date()}
                monthsShown={monthCount}
                renderCustomHeader={({
                    monthDate,
                    customHeaderCount,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                }) => {
                    const month = moment(monthDate).format("yyyy-MM");
                    if (!dayAmounts.months[month]) {
                        getAmounts(month, moment(monthDate).add(1, "month").format("yyyy-MM"));
                    }
                    return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            {customHeaderCount === 0 && (
                                <CustomIcon
                                    onClick={!prevMonthButtonDisabled ? decreaseMonth : () => ""}
                                    className={classNames("header-arrow", {
                                        disabled: prevMonthButtonDisabled,
                                    })}
                                    icon="arrowLeft"
                                />
                            )}
                            <Typography flex={1} justifyContent={"center"} className="header-text">
                                {t(monthNamesLocal[moment(monthDate).month()])}{" "}
                                {moment(monthDate).year()}
                            </Typography>
                            {(customHeaderCount === 1 || monthCount === 1) && (
                                <CustomIcon
                                    className="header-arrow"
                                    onClick={increaseMonth}
                                    icon="arrowRight"
                                />
                            )}
                        </Box>
                    );
                }}
                formatWeekDay={(date) => t(upperCase(date.substring(0, 3)))}
                renderDayContents={(day, date) => {
                    const amount = dayAmounts.days[moment(date).format("yyyy-MM-DD")] || {};
                    return (
                        <>
                            <span className={"day " + (amount.noPlace && "noplace")}>{day}</span>
                            <div className={"price " + (amount.noPlace && "noplace")}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: amount.currencyCode || "",
                                    }}
                                ></span>
                                {amount.price || ""}
                            </div>
                        </>
                    );
                }}
                locale={"en-gb"}
            />
        </Styled>
    );
};

export default RangePicker;
